import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TokenService } from '../token.service';
import { isPlatformBrowser } from '@angular/common';
import { PromptDialogComponent } from '../../component/prompt-dialog/prompt-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../environment.service';
import { ManageProfileService } from 'src/app/modules/settings/manage-profile/manage-profile.service';
import { PlanningDataService } from '../planning-data.service';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  constructor(
    public translate: TranslateService,
    private tokenService: TokenService,
    public _dialog: MatDialog,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public http: HttpClient, 
    public env: EnvironmentService,
    private _manageProfile: ManageProfileService,
    private planningDataService: PlanningDataService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  isUnsavedOrgWarningDialogOpen: boolean = false; 
  isBrowser: boolean;
  unreadNotfCount: number = 0;
  showDropDown: boolean = false;
  showData: boolean = false;
  manageOrganization: boolean = false;
  showLocationDetails: boolean = false;
  showOrgDetails: boolean = true;
  hasUnsavedOrgChanges: boolean = false;
  detailsCardTitle: string = this.translate.instant('location.title'); //organization or location details title
  organizationId: string = '';
  locationId: string = '';
  locationName: string = '';
  private selectedLocIdSubject = new BehaviorSubject<any>(null);
  selectedLocId$ = this.selectedLocIdSubject.asObservable();
  private organizationDetailsSubject = new BehaviorSubject<any>(null);
  organizationDetails$ = this.organizationDetailsSubject.asObservable();
  private locationDataSubject = new BehaviorSubject<any>(null);
  locationData$ = this.locationDataSubject.asObservable();
  private departmentDataSubject = new BehaviorSubject<any>(null);
  departmentData$ = this.departmentDataSubject.asObservable();
  private locWithDeptDataSubject = new BehaviorSubject<any>(null);
  locWithDeptData$ = this.locWithDeptDataSubject.asObservable();
  private staffDataSubject = new BehaviorSubject<any>(null);
  staffData$ = this.staffDataSubject.asObservable();
  private isSearchSidebarVisible = new BehaviorSubject<boolean>(false); //for search side bar
  searchSidebarVisibility$ = this.isSearchSidebarVisible.asObservable();
  private memberTypeDataSubject = new BehaviorSubject<any>(null);
  memberTypeData$ = this.memberTypeDataSubject.asObservable();
  loginUserImgSubject = new BehaviorSubject<any>(null);
  loginUserImg$ = this.loginUserImgSubject.asObservable();
  private languageSubject = new BehaviorSubject<string>('en');
  language$ = this.languageSubject.asObservable(); // Observable to listen for language changes
  activeTab: string = '/dashboard';
  address: string = '';
  selectedTab: string = '';
  userName: string;
  selDeptInPlanning: any;
  selDeptDupInPlanning: any; // manage department in planning header for unsaved changes warning message
  // selDateInPlanning: Date = new Date();
  // Initialize selDateInPlanning with the first day of the current month
  selDateInPlanning: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  selRouterLink: string
  userLoggedIn: boolean = false
  selDeptInActivity: any
  curMonInMonPicker: any = new Date(); // manage date in planning header for unsaved changes warning message
  isChildNotifyModalOpen:boolean = false;//added this boolean to prevent the daily duty popup from closing when clicking inside either on notify to pool or review notification popups
  isTimeDifferenceModalOpen:boolean = false;//added this boolean to prevent the daily allocation popup from closing when clicking inside TimeDifference Modal
  selPlanningView:string
  private timeDifferenceSubject = new Subject<any>();
  removeTimeDifference$ = this.timeDifferenceSubject.asObservable();

  private staffForTimesheetSubject = new BehaviorSubject<any>(null);
  staffForTimesheet$ = this.staffForTimesheetSubject.asObservable();
  private currentStaff: any = null;
  private localeSubject = new BehaviorSubject<string>(localStorage.getItem('locale') || 'de');
  locale$ = this.localeSubject.asObservable();
  staffProfileSubject = new BehaviorSubject<any>(null);
  staffProfile$ = this.staffProfileSubject.asObservable();
  private isApiInProgress = false;

  private _orgDetails = new BehaviorSubject<any>(null);
  private _orgLogo = new BehaviorSubject<string | null>(null);

  orgDetails$ = this._orgDetails.asObservable();
  orgLogo$ = this._orgLogo.asObservable();
  planFormSubmittedAvlbl: boolean = false
  planFormSubmitted: any
  private planFormSubmittedSubject = new BehaviorSubject<boolean>(true); // Start with false
  planFormSubmitted$ = this.planFormSubmittedSubject.asObservable();
  setOrgDetails(data: any) {
    this._orgDetails.next(data);
  }

  setOrgLogo(logoUrl: string) {
    this._orgLogo.next(logoUrl);
  }

  clearOrgData() {
    this._orgDetails.next(null);
    this._orgLogo.next(null);
  }

  //handle language change in home and header components
  setLocale(locale: string) {
    localStorage.setItem('locale', locale);
    this.localeSubject.next(locale);
  }

  setStaffForTimesheet(data: any) {
    this.currentStaff = data;
    sessionStorage.setItem('staffForTimesheet', JSON.stringify(data));
    this.staffForTimesheetSubject.next(data);
     const iframe: HTMLIFrameElement | null = document.getElementById('timesheet-iframe') as HTMLIFrameElement;
     if (iframe && iframe.contentWindow) {
       iframe.contentWindow.postMessage(
         { type: 'SET_STAFF_DATA', payload: data },
         '*'
       );
     }
  }

  getCurrentStaffForTimesheet() {
    if (this.currentStaff) return this.currentStaff;

    const stored = sessionStorage.getItem('staffForTimesheet');
    if (stored) {
      this.currentStaff = JSON.parse(stored);
      return this.currentStaff;
    }

    return null;
  }
  
  clearStaffForTimesheet() {
    this.staffForTimesheetSubject.next(null);
  }

  removeTimeDifference(data: any) {
    this.timeDifferenceSubject.next(data);
  }

  toggleSearchSidebar() {
    this.isSearchSidebarVisible.next(!this.isSearchSidebarVisible.value);
  }
  updateLocationData(data: any) {
    this.locationDataSubject.next(data);
  }

  updateSelectedLocId(data: any) {
    const currentData = this.selectedLocIdSubject.value;
    if (currentData !== data) {
      this.selectedLocIdSubject.next(data);
    }
  }

  updateorganizationDetails(data: any) {
    this.organizationDetailsSubject.next(data);
  }

  updateLoginUserImg(data: any) {
    this.loginUserImgSubject.next(data);
  }

  updateDashboardUserData(profile: any) {
    this.staffProfileSubject.next(profile);
  }

  clearLoginUserImg() {
    this.loginUserImgSubject.next(null);
  }

  updateDepartmentData(data: any) {
    this.departmentDataSubject.next(data);
  }

  updateStaffData(data: any) {
    this.staffDataSubject.next(data);
  }

  updateLocWithDeptData(data: any) {
    this.locWithDeptDataSubject.next(data);
  }

  updateMemberTypeData(data: any) {
    const currentData = this.memberTypeDataSubject.value;
    if (!this.areEqual(currentData, data)) {
      this.memberTypeDataSubject.next(data);
    }
  }

  deleteStaffImg(){
    let url = `staffs/profile/profile-image/remove`;
    return this.env.patch(url);
  }

  // Utility function to compare two data objects
  public areEqual(data1: any, data2: any): boolean {
    return JSON.stringify(data1) === JSON.stringify(data2);
  }

  prepareAddress(contact: any) {
    if (contact) {
      const parts = [
        contact.street,
        contact.streetNumber,
        contact.postalCode,
        contact.city,
        contact.country,
      ];
      this.address = parts?.filter((part) => part).join(', ');
      return this.address;
    } else {
      return null;
    }
  }

  setLanguage(selectedLang?: any) {
    let lang;
    let browserLang:any;
    if (selectedLang) {
      lang = selectedLang;
    } else {
      lang = this.tokenService.getLanguage();
    }
    this.translate.addLangs(['en', 'de', 'fr', 'it']);
    if (typeof window !== 'undefined' && window?.localStorage) {
      if (lang != null) {
        localStorage?.setItem('locale', lang);
      } else {
        localStorage?.setItem('locale', navigator.language);
      }
      browserLang = localStorage?.getItem('locale');
      this.languageSubject.next(browserLang); // Notify all components
      if (
        browserLang == 'en' ||
        browserLang == 'de' ||
        browserLang == 'fr' ||
        browserLang == 'it'
      ) {
        localStorage?.setItem('locale', browserLang);
        this.translate.reloadLang(browserLang);
        this.translate.use(browserLang);
      } else {
        browserLang = 'de';
        localStorage?.setItem('locale', browserLang);
        this.translate.reloadLang(browserLang);
        this.translate.use(browserLang);
      }
    }
  }

  convertToISO(dateString: string): string {
    // Split the date string into day, month, year
    const [day, month, year] = dateString.split('.').map(Number);

    // Create a Date object
    const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));

    // Return the ISO string format
    return date.toISOString();
  }

  convertToPartialISO(dateString: string): string {
    // Split the date string into day, month, and year components
    const [day, month, year] = dateString.split('.').map(Number);

    // Create a Date object
    const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 35));

    // Return the ISO string format
    return date.toISOString();
  }

  preparetDate(selectedMonth: number, selectedYear: number) {
    let month = selectedMonth;
    let year = selectedYear;
    if (month < 1 || month > 12) {
      throw new Error('Invalid month. Month should be between 1 and 12.');
    }

    // Create the start date as the first day of the month
    const startDate = new Date(year, month - 1, 1); // month - 1 because months are 0-indexed in JS

    // Create the end date as the last day of the month
    const endDate = new Date(year, month, 0); // 0 gets the last day of the previous month

    // Helper function to format the date as dd.mm.yyyy
    const formatDate = (date: Date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 because JS months are 0-indexed
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    };

    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    };
  }

  // Check if the selected month/year is allowed for planning
  nextMonthCheck(
    selectedMonth: number,
    selectedYear: number,
    planLimit: number,
    dueDay: number
  ): { canPlanNextMonth: boolean; canPlanPrevMonth: boolean } {

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-based
    const currentDay = today.getDate();

    // Calculate start and end range
    const startMonth = currentMonth;
    const startYear = currentYear;

    let endMonth = (startMonth + planLimit) % 12;
    let endYear = startYear + Math.floor((startMonth + planLimit) / 12);

    // Extend range if due day is passed in current month
    if (currentDay > dueDay) {
      endMonth = (endMonth + 1) % 12;
      if (endMonth === 0) endYear += 1;
    }

    // Convert to absolute month numbers
    const startAbs = startYear * 12 + startMonth;
    const endAbs = endYear * 12 + endMonth;
    const selectedAbs = selectedYear * 12 + selectedMonth;

    // Previous month button → true if selected month is before current month
    const canPlanPrevMonth = selectedAbs >= startAbs;

    // Allow planning if:
    // - Selected is in current month or after
    // - OR Selected is exactly one month before current month
    const canPlanNextMonth =
      (selectedAbs >= startAbs && selectedAbs <= endAbs) ||
      selectedAbs === startAbs - 1;

    return { canPlanNextMonth, canPlanPrevMonth };
  }

  //prepare gmt date format like Tue Oct 01 2024 00:00:00 GMT+0530 (India Standard Time)
  gmtDate(month: number, year: number) {
    const monthIndex = new Date(`${month} 1, ${year}`).getMonth(); // Get the month index (October = 9, because months are 0-based in JavaScript)
    const currentMonth = new Date(year, month - 1, 1); // Subtract 1 from the month, as months are 0-based in Date
    return currentMonth
  }
  convertTo24HourFormat(time: string | null): string | null {
    if (!time) return null;

    const [hour, minutePart] = time.split(':');
    const [minute, meridian] = minutePart.split(' ');

    let hour24 = parseInt(hour, 10);
    if (meridian === 'PM' && hour24 !== 12) {
      hour24 += 12;
    } else if (meridian === 'AM' && hour24 === 12) {
      hour24 = 0;
    }

    return `${hour24.toString().padStart(2, '0')}:${minute}`;
  }
  // to show warning message when the user leaves from the organisation component after unsaved changes in edit
  showWarningMessageDialog(): Promise<boolean> {
    return new Promise((resolve) => {
      this.isUnsavedOrgWarningDialogOpen = true;
      const dialogRef: MatDialogRef<PromptDialogComponent> = this._dialog.open(
        PromptDialogComponent,
        {
          width: '536px',
          height: '338px',
          disableClose: true,
          data: {
            iconName: 'info',
            title: 'prompt_dialog.title',
            message: 'prompt_dialog.content',
            buttons: ['prompt_dialog.back_btn', 'prompt_dialog.ok_btn'],
            buttonName: ['Back', 'OK'],
          },
        }
      );

      dialogRef.componentInstance.buttonClicked.subscribe(
        (buttonName: string) => {
          if (buttonName === 'OK') {
            this.hasUnsavedOrgChanges = false;
            dialogRef.close();this.isUnsavedOrgWarningDialogOpen = false;
            resolve(true);
            let selRouterLink = this.planningDataService.getSelRouterLink()
            this.router.navigateByUrl(selRouterLink);
          } else {this.isUnsavedOrgWarningDialogOpen = false;
            this.activeTab = '/organization';
            this.hasUnsavedOrgChanges = true;
            dialogRef.close();
            resolve(false);
          }
        }
      );
    });
  }

   private printTrigger = new Subject<any>();
  printTrigger$ = this.printTrigger.asObservable();

  triggerPrint(data: any) {
    this.printTrigger.next(data);
  }
  loadStaffProfile(): void {
    if (!this.loginUserImgSubject.value && !this.isApiInProgress && sessionStorage.getItem('LOGIN')) {
      this.isApiInProgress = true;
      this._manageProfile.getStaffData().subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            const profile = {
              ...res.body,
              imageUrl: res.body?.imageUrl
                ? `${this.env.imgReviewUrl}/${res.body.imageUrl}`
                : 'assets/image/no-profile.webp',
            };
            this.loginUserImgSubject.next(profile.imageUrl);
            this.staffProfileSubject.next(profile);
          }
          this.isApiInProgress = false;
        },
        error: () => {
          this.isApiInProgress = false;
        },
      });
    }
  }

  private isLocalStorageAvailable() {
    let locAvl = typeof window !== 'undefined' && !!window.localStorage;
    if (locAvl) {
      this.planFormSubmitted = sessionStorage.getItem('planFormSubmitted')
      this.planFormSubmittedAvlbl = this.planFormSubmitted !== null;
    }
  }
  setPlanFormSubmitted(planFormSubmitted:any){
    this.planFormSubmittedSubject.next(planFormSubmitted);
    sessionStorage.setItem('planFormSubmitted', planFormSubmitted); // Persist to localStorage
  }

  getPlanFormSubmitted(){
    this.isLocalStorageAvailable();
    if (this.planFormSubmittedAvlbl) {
      const storedData = this.planFormSubmitted;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  getPlanFormSubmittedObservable(): boolean {

    return sessionStorage.getItem('planFormSubmitted') === 'true';
  }

  clearPlanFormSubmitted() {
    sessionStorage.removeItem('planFormSubmitted'); // Clear from localStorage
  }

  compareWithPlanDate(date:any, planDate:any, type?:string){
    let isSameMonthYear
    if(type && type === 'dateObject'){
      isSameMonthYear =
      date.getFullYear() === planDate.selectedYear &&
      date.getMonth() + 1 === planDate.selectedMonth;
    }
    else{
      // Extract parts
      const [day, month, year] = date.split(".").map(Number);
    // Compare (note: planDate.selectedMonth is 0-based or 1-based?)
    // If 0-based (like JS Date), add 1 when comparing
      isSameMonthYear =
      planDate?.selectedYear === year &&
      (planDate?.selectedMonth === month);
    }
    return isSameMonthYear
  }
}

